module.exports = __webpack_public_path__ + "media/new/contact-flags-d83c8ba5.png";